(function () {
  function initPlp(root) {
    if (!root || root.dataset.svPlpReady) return;
    root.dataset.svPlpReady = '1';

    var grid = root.querySelector('[data-sv-plp-grid]');
    var storageKey = 'sv-plp-layout';

    function setLayout(layout) {
      if (!grid) return;
      grid.setAttribute('data-layout', layout);
      try {
        localStorage.setItem(storageKey, layout);
      } catch (e) {}
      root.querySelectorAll('[data-sv-layout]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-sv-layout') === layout);
      });
    }

    try {
      var saved = localStorage.getItem(storageKey);
      if (saved) setLayout(saved);
    } catch (e) {}

    root.querySelectorAll('[data-sv-layout]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setLayout(btn.getAttribute('data-sv-layout'));
      });
    });

    /* Sort modal */
    var sortModal = root.querySelector('[data-sv-sort]');
    var sortOpen = root.querySelector('[data-sv-sort-open]');
    function openSort() {
      if (!sortModal) return;
      sortModal.hidden = false;
      document.documentElement.classList.add('sv-plp-modal-open');
    }
    function closeSort() {
      if (!sortModal) return;
      sortModal.hidden = true;
      document.documentElement.classList.remove('sv-plp-modal-open');
    }
    if (sortOpen) sortOpen.addEventListener('click', openSort);
    root.querySelectorAll('[data-sv-sort-close]').forEach(function (el) {
      el.addEventListener('click', closeSort);
    });

    /* Filter drawer */
    var filterDrawer = root.querySelector('[data-sv-filter]');
    var filterOpen = root.querySelector('[data-sv-filter-open]');
    function openFilter() {
      if (!filterDrawer) return;
      filterDrawer.hidden = false;
      document.documentElement.classList.add('sv-plp-modal-open');
    }
    function closeFilter() {
      if (!filterDrawer) return;
      filterDrawer.hidden = true;
      document.documentElement.classList.remove('sv-plp-modal-open');
    }
    if (filterOpen) filterOpen.addEventListener('click', openFilter);
    root.querySelectorAll('[data-sv-filter-close]').forEach(function (el) {
      el.addEventListener('click', closeFilter);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeSort();
        closeFilter();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sv-plp]').forEach(initPlp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
